<template>
  <div class="w-full">
    <!-- <Header /> -->
    <HomeRegistered v-if="authenticated" />

    <HomeUnregistered v-else />
  </div>
</template>


<script>
import { mapGetters } from "vuex";
// import Header from "@/components/Header";
import HomeRegistered from "@/components/Home_unregistered";
import HomeUnregistered from "@/components/Home_unregistered";
export default {
  name: "Home",
  components: {
    // Header,
    HomeRegistered,
    HomeUnregistered,
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
    }),
  },
};
</script>
